var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{attrs:{"email":_vm.email},on:{"reset-password":function($event){return _vm.resetPassword($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }